import { gql } from 'graphql-request';

export default gql`query($filter: AccessoryFilterInput) {
  accessoryGroups(filter: $filter) {
    items {
        id
        name
        description
        accessories {
            id
            name
            description
            article
            picture_path
        }
    }
  }
}`;